import { Breadcrumbs } from 'components/bredcrambs';
import {
  BreadcrumbsProps,
  guidePage,
  blogPage,
} from 'constants/routes-breadcrumbs';

import styles from './styles.module.css';
import { IBlogPostType } from 'constants/types';

export const Main = ({
  name,
  type,
}: {
  name?: string;
  type?: IBlogPostType;
}) => {
  return (
    <main className={styles.main}>
      <div className={styles.container_s}>
        <div className={styles.page_header}>
          <Breadcrumbs
            enableAbsoluteOnMobile={false}
            items={[
              ...(type === 'guide' ? guidePage : blogPage),
              {
                id: 2,
                path: `/${type === 'guide' ? 'guide' : 'blog-and-news'}/${name}`,
                title: name,
              } as BreadcrumbsProps,
            ]}
          />
        </div>
      </div>
    </main>
  );
};
